import {
  createDenormalizeSelector,
  createSingleEntitySelector,
} from '../modules/entities';
import { clientLinkedEntities, clientSchema } from './actions';
import { ClientGlobalState, CLIENT_MODULE_KEY } from './reducer';
import { Client } from './definition';

type GlobalState = ClientGlobalState;

export const selectCurrentClientId = (state: GlobalState): string | undefined =>
  state[CLIENT_MODULE_KEY].currentClient;

export const selectCurrentClient = createSingleEntitySelector<
  GlobalState,
  Client
>(clientSchema, selectCurrentClientId, clientLinkedEntities);

export const createClientByIdSelector = () =>
  createDenormalizeSelector<Client>(clientSchema, clientLinkedEntities);
